// Human-readable labels for media title codes. Shared by the dashboard
// (apps/web report sections) and the CSV export (apps/api) so both read the same.

// GA media title keys (StoryKPIs.byMediaTitle[*].key)
export const gaMediaTitleLabels: Record<string, string> = {
  "20min": "20 Minuten",
  "24heures": "24 heures",
  annabelle: "Annabelle",
  bazonline: "Basler Zeitung",
  bernerzeitung: "Berner Zeitung",
  bilan: "Bilan",
  contentHub: "Content Hub",
  cp: "Commercial Publishing",
  derbund: "Der Bund",
  encore: "Encore",
  femina: "Femina",
  fuw: "Finanz und Wirtschaft",
  lb: "Der Landbote",
  lematin: "Le Matin",
  lifestyle: "20 Minuten Lifestyle",
  tagesanzeiger: "Tages Anzeiger",
  tagi: "Tages Anzeiger",
  tdg: "Tribune de Genève",
  tio: "Tio",
  zsz: "Zürichsee Zeitung",
  zul: "Zürcher Unterländer",
};

// DFP / CRASS creative media title codes (CrassCreative.media_title_codes)
export const dfpMediaTitleLabels: Record<string, string> = {
  "20minuten-front": "20 Minuten Front",
  "20minuten-wettbewerb": "20 Minuten Wettbewerb",
  "20minuten-DE": "20 Minuten",
  "20minutes-FR": "20 minutes",
  "20minuti-Tio-IT": "tio",
  Annabelle: "Annabelle",
  Bilan: "Bilan",
  "encore-DE": "Encore",
  "encore-FR": "Encore",
  Femina: "Femina",
  FUW: "Finanz und Wirtschaft",
  "NN-Baslerzeitung": "Basler Zeitung",
  "NN-Berneroberlaender": "Berner Oberländer",
  "NN-Bernerzeitung": "Berner Zeitung",
  "NN-Derbund": "Der Bund",
  "NNf-24heures": "24 heures",
  "NNf-Lematin": "Le Matin",
  "NNf-Tdg": "Tribune de Genève",
  "NN-Langenthalertagblatt": "Langenthaler Tagblatt",
  "NN-Tagesanzeiger": "Tages Anzeiger",
  "NN-Thunertagblatt": "Thuner Tagblatt",
  NNz_Landbote: "Der Landbote",
  NNz_ZuercherUnterlaender: "Zürcher Unterländer",
  NNz_ZuerichseeZeitung: "Zürichsee Zeitung",
};
